import { render } from "./GlobalWidgetBlockForm.vue?vue&type=template&id=a9291546"
import script from "./GlobalWidgetBlockForm.vue?vue&type=script&lang=js"
export * from "./GlobalWidgetBlockForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__